import { Fragment } from "react";
import NavigationItem from "./NavigationItem";
import NavigationLink from "./NavigationLink";
import { SidebarItemType } from "../../js/enums";

function Navigation({
  display,
  navigationItems,
  subDisplay,
  toggleDisplay,
  toggleSubDisplay,
}) {
  return (
    <div id="nav-wrapper">
      <ul className="nav flex-column mb-3">
        {navigationItems &&
          navigationItems.length > 0 &&
          navigationItems.map((item, itemIndex) => {
            if (
              item.itemType === SidebarItemType.Page &&
              item.link &&
              item.link.to &&
              item.link.text
            ) {
              return (
                <NavigationLink
                  key={`nav-${itemIndex}`}
                  to={item.link.to}
                  text={item.link.text}
                  openInNewTab={item.link.openInNewTab}
                  url={item.link.url}
                  className={"itemPage"}
                />
              );
            } else if (
              item.itemType === SidebarItemType.Section &&
              item.id &&
              item.text &&
              item.subItems &&
              item.subItems.length > 0
            ) {
              return (
                <NavigationItem
                  className={"parentItem"}
                  key={`nav-${itemIndex}`}
                  id={item.id}
                  onClick={() => {
                    toggleDisplay(item.id);
                  }}
                  show={display === item.id}
                  text={item.text}
                >
                  {item.subItems.map((subItem, subItemIndex) => {
                    if (
                      subItem.itemType === SidebarItemType.Page &&
                      subItem.link &&
                      subItem.link.to &&
                      subItem.link.text
                    ) {
                      return (
                        <NavigationLink
                          key={`nav-${itemIndex}-${subItemIndex}`}
                          item={item}
                          to={subItem.link.to}
                          text={subItem.link.text}
                          openInNewTab={subItem.link.openInNewTab}
                          url={subItem.link.url}
                          className={"subItemPage"}
                        />
                      );
                    } else if (
                      subItem.itemType === SidebarItemType.Section &&
                      subItem.id &&
                      subItem.text &&
                      subItem.links &&
                      subItem.links.length > 0
                    ) {
                      return (
                        <NavigationItem
                          className={"subItem"}
                          key={`nav-${itemIndex}-${subItemIndex}`}
                          id={subItem.id}
                          onClick={() => toggleSubDisplay(subItem.id)}
                          show={subDisplay === subItem.id}
                          text={subItem.text}
                        >
                          {subItem.links.map((link, linkIndex) => (
                            <NavigationLink
                              key={`nav-${itemIndex}-${subItemIndex}-${linkIndex}`}
                              item={item}
                              to={link.to}
                              text={link.text}
                              openInNewTab={link.openInNewTab}
                              url={link.url}
                              className={"subItemSectionPage"}
                            />
                          ))}
                        </NavigationItem>
                      );
                    }
                    return (
                      <Fragment
                        key={`nav-${itemIndex}-${subItemIndex}`}
                      />
                    );
                  })}
                </NavigationItem>
              );
            }
            return <Fragment key={`nav-${itemIndex}`} />;
          })}
      </ul>
    </div>
  );
}

export default Navigation;
